import {UserRepository} from "@api/repositories/UserRepository";
import {UserProfile} from "@api/models/UserProfile";
import Vue from "vue";

export class UserProfilesService {
    profiles: Record<number, UserProfile> = Vue.observable({});
    checkResult: Record<number, boolean> = {};
    fetchingIds: number[] = [];

    constructor(
        private readonly usersRepository: UserRepository
    ) {
    }

    needToBeFetched(userId: number) {
        return !this.profiles[userId] && this.fetchingIds.indexOf(userId) < 0;
    }

    async fetchProfile(userId: number): Promise<UserProfile | null> {
        if (this.needToBeFetched(userId)) {
          try {
              this.fetchingIds.push(userId);
              let profile: UserProfile | null = await this.usersRepository
                  .profile(userId, ["id", "userId", "lastName", "firstName", "photoFileId", "company", "position"]);

              profile && this.setProfile(profile);
              // Vue.set(this.profiles, userId, profile);
              console.log('profile loaded', this.profiles);
              return profile;
          }
          catch (e) {
              console.log('Profile fetching', `couldn't load profile for ${userId}`);
              return null;
          }
          finally {
              this.fetchingIds = this.fetchingIds.filter(item => item != userId);
          }
        }

        return this.profiles[userId];
    }

    setProfile(userProfile: UserProfile): void {
        Vue.set(this.profiles, userProfile.userId as number, userProfile);
    }

    clean(): void {
        this.profiles = {};
        this.checkResult = {};
        this.fetchingIds = [];
    }
}
